import Show from 'settings/laborConsultant/Show'
import Update from 'settings/laborConsultant/Update'
export default {Show, Update}
